export default __webpack_public_path__ + "static/media/mitsuha-running.800e4178.gif";